import { AppService } from './../../private/services/app.service';
import { environment } from 'src/environments/environment';
import { StorageListenerService } from './../../private/services/StorageListener.service';
// import { ISort } from './../../models/ISort';
import {
  Component,
  ViewChild,
  OnInit
} from '@angular/core';
import Swiper, { Autoplay } from 'swiper';
Swiper.use([Autoplay]);
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BookmarkService } from 'src/app/private/services/bookmark.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { animate, style, transition, trigger } from '@angular/animations';
import { AppComponent } from 'src/app/app.component';
import { EventsService } from 'src/app/private/services/events.service';
import { EncrDecrService } from 'src/app/private/services/encr-decr.service';
import { SponsoredEventsService } from 'src/app/private/admin/services/sponsored-events.service';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('1s ease-out', style({ height: 300, opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: 300, opacity: 1 }),
        animate('1s ease-in', style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
})
export class MainComponent implements OnInit {
  // =============================================================================
  // VARIABLES AND CONSTANTS
  // =============================================================================
  // sortForm: FormGroup;
  // Sorting Value
  // sort: ISort[] = [
  //   { value: '1, asc', viewValue: 'Price Low - High' },
  //   { value: '1, desc', viewValue: 'Price High - Low' },
  //   { value: '3, asc', viewValue: 'A - Z' },
  //   { value: '3, desc', viewValue: 'Z - A' },
  //   { value: '2, desc', viewValue: 'Popularity' },
  // ];

  //BANNER VARIABLES AND CONSTANTS
  featuredBanner = false;
  itemsPerSlideFeatured: number;
  // singleSlideOffset = false;

  eventsTitle;

  featuredEvents:any = [];
  allEvents;

  sponsoredEvents: any[] = []
  sponsoredEventsData: any[] = []
  bookedEvents: any[] = [];
  eventDetails: any = [];
  _eventsListener: Subscription;
  _pastEventsListener:Subscription;
  paidEvents:any = []
  freeEvents:any = []
  allFeesEvents:any = []
  popularitySort:any = []
  free:boolean = false
  paid:boolean = false
  all:boolean = true
  isPassedEvents:boolean=false;

  isSearch:boolean=false;
  firstDate
  lastDate

  loggedIn:boolean=false

  searchEvents:any = []
  passedEvents:any = []
  currentEvents:any = []

  eventDates:any = []

  sortPopularity:boolean = true

  start_date:string = ""
  end_date:string = ""

  itemsPerSlide = 5;
  singleSlideOffset = true;
  noWrap = true;

  // Event Type
  EVENT_TYPE_STANDARD = 'STANDARD';
  EVENT_TYPE_FEATURED = 'FEATURED';
  EVENT_TYPE_SPONSORED = 'SPONSORED';
  EVENT_TYPE_AD = 'AD';
  // Event Status
  EVENT_STATUS_CREATED = 'CREATED';
  EVENT_STATUS_APPROVED = 'APPROVED';
  EVENT_STATUS_REJECTED = 'REJECTED';
  EVENT_STATUS_ACTIVE = 'ACTIVE';
  EVENT_STATUS_CANCELLED = 'CANCELLED';
  EVENT_STATUS_FINISHED = 'FINISHED';

  //Features Status
  ratingFeature:boolean = environment.ratingFeature
  numberOfViewsFeature:boolean = environment.numberOfViewsFeature
  feesFeature:boolean = environment.feesFeature

  @ViewChild('placesRef') placesRef: GooglePlaceDirective;

  // ===========================================================================
  // CONSTRUCTOR
  // ===========================================================================
  constructor(
    private router: Router,
    private bookmarkService: BookmarkService,
    private formBuilder: FormBuilder,
    private storageListenerService:StorageListenerService,
    private appComponent: AppComponent,
    private eventService: EventsService,
    private route: ActivatedRoute,
    private appService: AppService,
    private encDecrService: EncrDecrService,
    private sponsoredEventsService: SponsoredEventsService
  ) {
  }

  // =============================================================================
  // ON INIT
  // =============================================================================
  async ngOnInit() {
    // -------------------------------------------------------------------------
    // RedirectCall after signin/signup using google/facebook
    // -------------------------------------------------------------------------
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token != null) {
      this.appService
        .redirectCall(token)
        .then((res: any) => {
          this.encDecrService.encryptJsonDataToStorage(
            'user',
            JSON.stringify(res.user)
          );
          this.appComponent.isLoggedIn = true;
          this.loggedIn = true
          if (res.user.avatar != null) this.appComponent.userImage = res.user.avatar;
          this.router.navigate(['main']);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (this.appComponent.isLoggedIn) this.loggedIn = true

    // this.sortForm = this.formBuilder.group({
    //   sort: '',
    // });

    if(localStorage.getItem('events')) {
      this.allEvents = JSON.parse(localStorage.getItem('events'))
      this.test()
      // this.eventsTitle = JSON.parse(localStorage.getItem('eventsTitle'))
    }
      this._eventsListener = this.storageListenerService.watchStorage().subscribe((data: any) => {

      if (data == 'stored events') {
        this.allEvents = JSON.parse(localStorage.getItem('events'))
        this.featuredEvents = []
    // -------------------------------------------------------------------------
    // check if event has passed
    // -------------------------------------------------------------------------
        for (let k=0;k<this.allEvents.length; k++){
          if(this.allEvents[k].type !== "ad"){
          let dates: any[] = this.allEvents[k].event_dates;
          let validDates: any[] = [];
          dates.forEach((date) => {
            if (new Date(date.date) > new Date() || new Date(date.date).toDateString() === new Date().toDateString()) validDates.push(date)
          });
          this.allEvents[k].event_dates = validDates;
          if (validDates.length < 1 || validDates == undefined)this.allEvents[k].passedEvent = true
          else if(validDates.length == 1){
            this.allEvents[k].firstDate= validDates[0].date
            this.allEvents[k].passedEvent = false
          }
          else {
          this.allEvents[k].passedEvent = false
          this.allEvents[k].firstDate = validDates[0].date
          let indexOfArray = validDates.length -1
          this.allEvents[k].lastDate = validDates[indexOfArray].date
          }
        }
        if(this.allEvents[k].type === "featured"){
          this.featuredEvents.push(this.allEvents[k])
        }
        
        }
        // this.allFeesEvents = this.allEvents
        for(let j=0; j<this.featuredEvents.length; j++){
        for(let i=0; i<this.allEvents.length; i++){
            if(this.allEvents[i].id == this.featuredEvents[j].id && this.allEvents[i].type !== "ad"){
              this.allEvents.splice(i,1);
            }
          }
        }
        this.eventsTitle = JSON.parse(localStorage.getItem('eventsTitle'))
        this.allFeesEvents = this.allEvents
        
        this.sortPaidFree()
        this.check()

        if (this.appComponent.isLoggedIn) {
        this.eventService.myPickedEvents().then((res: any) => {
          if (res.error != "Unauthorized") {
            let x: any[] = res.picked_events;
            x.forEach((res) => {this.bookedEvents.push(res.event_date_id)})
          }
        })
          .catch((error) => {
            console.log(error)
          })
        } 
        this.start_date = ""
        this.end_date = ""
        if(this.sortPopularity)this.sortByPopularity(); else this.sortByTime()
      }
        
    
    })


    this._pastEventsListener = this.storageListenerService.watchStorage().subscribe((data:any)=>{
      this.passedEvents = []
      this.currentEvents = []
      if(data == 'is search true'){
        if(localStorage.getItem('events')){
          this.allEvents = JSON.parse(localStorage.getItem('events'))
        }
        let now = new Date();
        this.isSearch = true;
        this.isPassedEvents = true;
        this.allEvents = this.allEvents.map(item => ({
          ...item,
          passedEvent:true,
          firstDate: '',
          lastDate: ''
        }));
       this.passedEvents = this.allEvents
        for(let i=0;i<this.allEvents.length; i++){
          if(this.allEvents[i].type !== "ad"){
          let lastIndex:number = this.allEvents[i].event_dates.length - 1
          if(new Date(this.allEvents[i].event_dates[lastIndex].date) > now || new Date(this.allEvents[i].event_dates[lastIndex].date) === now){
            this.currentEvents.push(this.allEvents[i])
          }
        }
        }
        for (let k=0;k<this.currentEvents.length; k++){
          let dates: any[] = this.currentEvents[k].event_dates;
          let validDates: any[] = [];
          dates.forEach((date) => {
            if (new Date(date.date) > new Date() || new Date(date.date).toDateString() === new Date().toDateString())validDates.push(date)});
          this.currentEvents[k].event_dates = validDates;
          if (validDates.length < 1 || validDates == undefined){this.currentEvents[k].passedEvent = true}
          else if(validDates.length == 1){
            this.currentEvents[k].firstDate= validDates[0].date
            this.currentEvents[k].passedEvent = false
          }
          else {
            this.currentEvents[k].passedEvent = false
          this.currentEvents[k].firstDate = validDates[0].date
          let indexOfArray = validDates.length -1
          this.currentEvents[k].lastDate = validDates[indexOfArray].date
          }
        }
        this.allEvents = this.currentEvents
      }
      else{
        this.isPassedEvents = false;
        this.isSearch = false;
      }
    })

    


  }

  // ===========================================================================
  // ON DESTROY
  // ===========================================================================
  ngOnDestroy(): void {
    this._eventsListener.unsubscribe()
    this._pastEventsListener.unsubscribe()
  }

  test(){
    for (let k=0;k<this.allEvents.length; k++){
      if(this.allEvents[k].type !== "ad"){
      let dates: any[] = this.allEvents[k].event_dates;
      let validDates: any[] = [];
      dates.forEach((date) => {
        if (new Date(date.date) > new Date() || new Date(date.date).toDateString() === new Date().toDateString()) validDates.push(date)
      });
      this.allEvents[k].event_dates = validDates;
      if (validDates.length < 1 || validDates == undefined)this.allEvents[k].passedEvent = true
      else if(validDates.length == 1){
        this.allEvents[k].firstDate= validDates[0].date
        this.allEvents[k].passedEvent = false
      }
      else {
      this.allEvents[k].passedEvent = false
      this.allEvents[k].firstDate = validDates[0].date
      let indexOfArray = validDates.length -1
      this.allEvents[k].lastDate = validDates[indexOfArray].date
      }
    }
    if(this.allEvents[k].type === "featured"){
      this.featuredEvents.push(this.allEvents[k])
    }
    
    }
    for(let j=0; j<this.featuredEvents.length; j++){
    for(let i=0; i<this.allEvents.length; i++){
        if(this.allEvents[i].id == this.featuredEvents[j].id && this.allEvents[i].type !== "ad"){
          this.allEvents.splice(i,1);
        }
      }
    }
  }
  // ===========================================================================
  // setting featured events banner slides, if there are more than 3 featured events display 3 items per slide
  // if there are less than 3 events, items per slide will be the number of featured
  // this in case there are 1 or 2 featured events so they fit the page in width
  // ===========================================================================
  setBannerSetting() {
    // if (this.featuredEvents.length > 3) {
    //   this.itemsPerSlideFeatured = 3;
    //   this.featuredBanner = true;
    // } else if (this.featuredEvents.length == 0) {
    //   this.featuredBanner = false;
    // } else {
    //   this.itemsPerSlideFeatured = this.featuredEvents.length;
    //   this.featuredBanner = true;
    // }
  }

  // ===========================================================================
  // Sort events by name, price and popularity
  // ===========================================================================
  sortEvent() {
    // this.getEvents();
  }

  // =============================================================================
  // Bookmark An Event
  // =============================================================================
  bookmarkEvent(event) {
    if (this.appComponent.isLoggedIn) {
    let data = {
      event_id: event.id,
    };
    this.bookmarkService
      .bookmarkEvent(data)
      .then((res) => {
        if (event.bookmark != null) {
          event.bookmark = null;
        } else {
          event.bookmark = '';
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }else{
      this.appComponent.showLogin();
    }
  }

  isCheckedAndDisabled(item) {
      if (this.bookedEvents.includes(item.id))
      return true;
    return false;
  }

  login(){
    if (!this.appComponent.isLoggedIn){
      this.appComponent.showLogin()
    }
  }

  book(date, item) {
    if (this.appComponent.isLoggedIn) {
      let data =
      {
        "event_id": parseInt(item.id),
        "event_date_id": parseInt(date.id)
      };
      if (this.bookedEvents.includes(date.id)){
        this.eventService.unPickEvent(data)
        .then((res) => {
        })
        .catch((error) => {
          console.log(error)
        })
      }
      else this.eventService.pickEvent(data)
        .then((res) => {
        })
        .catch((error) => {
          console.log(error)
        })
    }
    else {
      this.appComponent.showLogin();
    }
  }

  // =============================================================================
  // Get sort option (BY & ORDER)
  // =============================================================================
  getSortOptions() {
    // let sortDetails: string = this.sortForm.get('sort').value;
    // if (sortDetails == null || sortDetails == '')
    //   return {
    //     sortby: '',
    //     sortOrder: '',
    //   };
    // else {
    //   let sortValues: string[] = sortDetails.split(',');
    //   return {
    //     sortby: sortValues[0],
    //     sortOrder: sortValues[1],
    //   };
    // }
  }


  // ===========================================================================
  // Right side ribbon action
  // ===========================================================================
  addEventRightSide() {
    // if (this.appComponent.isLoggedIn === false) {
    //   this.appComponent.showRegister();
    // } else if (this.appComponent.isLoggedIn === true) {
    //   this.router.navigate(['/addevent']);
    // }
  }

  // ===========================================================================
  // Navigate to event page
  // ===========================================================================
  goToEventPage(item) {
    this.router.navigate(['event', item.link]);
  }


  sortPaidFree(){
    this.freeEvents = []
    this.paidEvents = []
    this.allEvents = this.featuredEvents.concat(this.allEvents)
    for (let i=0; i<this.allEvents.length; i++){
    if ((this.allEvents[i].min_fee == 0) && (this.allEvents[i].max_fee == 0)){
      this.freeEvents.push(this.allEvents[i])
    } else if ((this.allEvents[i].min_fee != 0 && this.allEvents[i].min_fee != null) && (this.allEvents[i].max_fee != 0 && this.allEvents[i].max_fee != null)){
      this.paidEvents.push(this.allEvents[i])
    }
  }
  }

  showAll(){
    this.all = true
    this.free = false
    this.paid = false
    // this.check()
    if(this.sortPopularity)this.sortByPopularity(); else this.sortByTime()
    // this.allFeesEvents = this.featuredEvents.concat(this.allFeesEvents)
  }

  showFree() {
    this.free = true
    this.all = false
    this.paid = false
    this.check()
  }

  showPaid() {
    this.paid = true
    this.all = false
    this.free = false
    this.check()
  }

  check(){
    if (this.paid == true){
      this.allEvents = this.paidEvents
    } else if (this.free == true){
     this.allEvents = this.freeEvents
    } else {
      this.allEvents = this.allFeesEvents
      console.log(this.allFeesEvents)
    }
  }

  sortByPopularity(){
    // this.showAll()
    this.all = true
    this.free = false
    this.paid = false
    this.allEvents = this.allFeesEvents
    let ads:any = []
    for(let i=0; i<this.allEvents.length;i++){
      if (this.allEvents[i].type == 'ad'){
        ads.push(this.allEvents[i]);
        this.allEvents.splice(i,1);
      }
      // if (this.allEvents[i].type == 'featured'){
      //   this.allEvents.splice(i,1);
      // }
    }
    this.allEvents.sort((a, b) => b.visit - a.visit);
    this.sortPopularity = true
    if(ads.length>=2){
    this.allEvents.splice(4, 0, ads[0]);
    this.allEvents.splice(13, 0, ads[1]);
    }
    this.allEvents = [
      ...this.featuredEvents,
      ...this.allEvents,
    ];
     }

  sortByTime(){
    // this.showAll()
    this.all = true
    this.free = false
    this.paid = false
    this.allEvents = this.allFeesEvents
    let ads:any = []
    for(let i=0; i<this.allEvents.length;i++){
      if (this.allEvents[i].type == 'ad'){
        ads.push(this.allEvents[i]);
        this.allEvents.splice(i,1);
      }
      // if (this.allEvents[i].type == 'featured'){
      //   this.allEvents.splice(i,1);
      // }
    }
    this.allEvents.sort((a,b) => parseFloat(a.event_dates[0].start_time) - parseFloat(b.event_dates[0].start_time))
    this.sortPopularity = false
    if(ads.length>=2){
    this.allEvents.splice(4, 0, ads[0]);
    this.allEvents.splice(13, 0, ads[1]);
    }
    this.allEvents = [
      ...this.featuredEvents,
      ...this.allEvents,
    ];
  }

  dateRange(){
    if(this.start_date != undefined && this.end_date != undefined){
    let date_range : any = []
    date_range.push(this.start_date)
    date_range.push(this.end_date)
    this.storageListenerService.set('date_range', date_range, 'stored date range');
    }
  }

  showAllEvents(){
    this.isPassedEvents =!this.isPassedEvents
    this.allEvents = this.passedEvents
  }

  showCurrentEvents(){
    this.isPassedEvents =!this.isPassedEvents
    this.allEvents = this.currentEvents
  }

  navigateAds(link,url){
    if(link != undefined)window.open("https://"+link, "_blank")
    if(url != undefined)window.open("https://"+url, "_blank")
  }
}
